import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { months, shortenandHoverString } from '../../../Components/helper';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function ExpandedViewForProductAttribute({
  expandedData,
  hanldeUpdate,
  showCreatedModifiedBy,
  handleDelete,
  statusCalled,
  statusColourCalled,
  selectedIdArray,
  onSelectCheckBox,
  supplierOptions,
  expandGrandTotalChild,
  parentIndexes,
  item,
  subbrandAccess,
}) {
  const ProductTestingData = useSelector((redState) => redState);
  const { UserDetails, BOMConfigDetails, Measuremets } = ProductTestingData;
  const { ProductColourList } = Measuremets;
  const { isSupplierLoggedIn } = UserDetails;
  const { isProductArchived } = BOMConfigDetails;
  const { t } = useTranslation('common');

  const checkBox = (ele) => {
    return (
      !isSupplierLoggedIn &&
      !isProductArchived && (
        <td className=" text-left">
          <div className="common-checkbox no-label checkbox-center">
            <input
              onChange={(e) => onSelectCheckBox(e, ele.idPlusSupplierId)}
              name={`checking_${ele.idPlusSupplierId}`}
              id={`checking_${ele.idPlusSupplierId}`}
              type="checkbox"
              checked={selectedIdArray.filter((val) => val === ele.idPlusSupplierId).length > 0}
            />
            <label htmlFor={`checking_${ele.idPlusSupplierId}`} className="chklabel" />
          </div>
        </td>
      )
    );
  };

  const actionButtons = (ele) => {
    return (
      <>
        <CustomTooltip placement="top" tooltipText={t('FILTER.UPDATE')}>
          <button className="btn p-0" aria-label="update" type="button" onClick={() => hanldeUpdate(ele)}>
            <span className="icon-Update-1 f-20" />
          </button>
        </CustomTooltip>

        {showCreatedModifiedBy()}
        <CustomTooltip placement="top" tooltipText={t('DEVLOPMENT_ORDER.PRODUCT_BOM_MODAL.EXPAND_VIEW_PRODUCT_ATTRIBUTES.DELETE')}>
          <button className="btn  p-0" type="button" aria-label="delete">
            <span className="icon-Delete f-20" onClick={() => handleDelete(ele?._id)} />
          </button>
        </CustomTooltip>
      </>
    );
  };

  const componentSupplierConfirmation = (obj) => {
    let compSuppsName = '';
    if (Array.isArray(obj?.colourRefsData) && obj?.colourRefsData?.length > 0) {
      obj?.colourRefsData?.forEach((ele) => {
        if (ele?.colourWayId === obj?.colour[0]?._id) {
          ele?.colourRefsDataAsPerSuppliers?.forEach((refsData) => {
            if (refsData?.tier1Supplier === obj?.supplier[0]?._id) {
              supplierOptions?.forEach((supplier) => {
                if (supplier?._id === refsData?.componentSupplier) {
                  compSuppsName = supplier?.name;
                }
              });
            }
          });
        }
        if (Array.isArray(obj?.componentSupp) && Array.isArray(ele.colourRefsDataAsPerSuppliers)) {
          ele?.colourRefsDataAsPerSuppliers?.forEach((refsData) => {
            if (
              ele?.colourWayId === obj?.colour[0]?._id &&
              refsData?.componentSupplier === obj?.componentSupp[0]?.supplierId &&
              refsData?.tier1Supplier === obj?.supplier[0]?._id
            ) {
              compSuppsName = obj.componentSupp.map((compSupp) => compSupp?.supplierName).join(', ');
            }
          });
        }
      });
    }
    return !isEmpty(compSuppsName) ? compSuppsName : '-';
  };
  // changes KJ
  const colourRefs = (obj) => {
    let colourName = '';
    const supplierIds = obj?.suppliers.map((ele) => ele?._id);
    const colourIds = obj?.colourLibraries.map((ele) => ele?._id);
    if (Array.isArray(obj?.colourRefsData) && obj?.colourRefsData?.length > 0) {
      obj?.colourRefsData?.forEach((ele) => {
        if (ele.colourWayId === obj?.colour?.[0]?._id) {
          const checkFoundSupplier = ele?.colourRefsDataAsPerSuppliers?.filter(
            (vl) => obj?.supplier?.[0]?._id === vl?.tier1Supplier && supplierIds.includes(vl?.tier1Supplier),
          );
          if (colourIds?.includes(ele?.colourWayId)) {
            const checkRefs = ele?.colourRefsDataAsPerSuppliers?.map((vl) => vl?.colourRef);
            const refs = ProductColourList?.filter((vl) => checkRefs.includes(vl?._id)).map((vl) => vl?.name);
            colourName = refs.join(', ');
          }
        }
      });
    }
    return !isEmpty(colourName) ? colourName : '-';
  };
  // changes KJ
  const colourConfirmation = (obj) => {
    let colourConfirm = '';
    const supplierIds = obj?.suppliers.map((ele) => ele?._id);
    const colourIds = obj?.colourLibraries.map((ele) => ele?._id);
    if (Array.isArray(obj?.colourRefsData) && obj?.colourRefsData?.length > 0) {
      obj?.colourRefsData?.forEach((ele) => {
        if (ele.colourWayId === obj?.colour?.[0]?._id) {
          if (colourIds?.includes(ele?.colourWayId)) {
            const checkRefs = ele?.colourRefsDataAsPerSuppliers?.map((vl) => vl?.colourRefName);
            const refs = ProductColourList?.filter((vl) => checkRefs.includes(vl?._id)).map((vl) => vl?.name);
            colourConfirm = refs.join(', ');
          }
        }
      });
    }
    return !isEmpty(colourConfirm) ? colourConfirm : '-';
  };

  const hideExpandedData = (childItem, childIndex) => {
    return (
      <td>
        {childIndex === 0 && (
          <button
            className="btn-up-down"
            type="button"
            aria-label="expand"
            onClick={() => {
              item.forEach((ele, is) => {
                if (ele?.expandData?.length > 1) {
                  parentIndexes.forEach((chEle, inds) => {
                    if (chEle === childItem.idPlusSupplierId) {
                      const r = item[is].expandData.filter((element) => element.idPlusSupplierId === chEle);
                      if (!isEmpty(r)) {
                        expandGrandTotalChild(is, inds);
                      }
                    }
                  });
                }
              });
            }}
          >
            <span className="icon-new-down-arrow-icon f-32 icon-inverse" />
          </button>
        )}
      </td>
    );
  };

  const handleMonths = (ele) => {
    const mnth = months.filter((obj) => obj._id === ele?.month);
    return !isEmpty(mnth) && mnth[0].name;
  };

  return expandedData?.map((childItem, childIndex) => {
    return (
      <tr key={childItem?._id}>
        {checkBox(childItem)}
        {hideExpandedData(childItem, childIndex)}
        <td className="text-left first-fix-col">
          {' '}
          <div>
            <span className="product-bom-ref">
              <a
                href={`${window.location.origin}/development-order/${childItem?._id}/bom`}
                target="_blank"
                className="text-black product-name-underline"
                rel="noopener noreferrer"
              >
                {childItem?.number}
              </a>
            </span>
          </div>
        </td>
        <td className="text-left">{shortenandHoverString(childItem?.description, 50)}</td>
        <td className="text-left">
          <div>
            <span>{childItem?.supplier[0]?.name} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{componentSupplierConfirmation(childItem)} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{childItem?.brandId?.name} </span>
          </div>
        </td>
        {subbrandAccess && (
          <td className="text-left">
            <div>
              <span>{childItem?.subBrandId?.name || '-'} </span>
            </div>
          </td>
        )}
        <td className="text-left">
          <div>
            <span>{childItem?.seasonId?.name} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{handleMonths(childItem)} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{childItem?.year} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{childItem?.catOneId?.name} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{childItem?.catTwoId?.name} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{childItem?.catThreeId?.name} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{childItem?.catFourId?.name} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{childItem?.size} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{childItem?.weight} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{childItem?.quantity} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{childItem?.statusId?.name} </span>
          </div>
        </td>
        <td className="text-left">
          <div>{Array.isArray(childItem?.colour) ? childItem?.colour[0]?.name : childItem?.colour?.name}</div>
        </td>
        <td className="text-left">
          <div>
            <span>{colourRefs(childItem)} </span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{colourConfirmation(childItem)}</span>
          </div>
        </td>
        <td className="text-left">
          <div>
            <span>{childItem?.isMatch ? 'Yes' : 'No'} </span>
          </div>
        </td>
        <td className="last-fix-col">
          <div>
            <strong> {t('FILTER.QUALITIES')}</strong> {statusCalled(childItem)}
            <br />
            <strong> {t('FILTER.COLOUR')}</strong> {statusColourCalled(childItem)}
          </div>
        </td>

        <td className="text-right">
          <div className="action-btns justify-content-end new-listing-action d-flex align-items-center">{actionButtons(childItem)}</div>
        </td>
      </tr>
    );
  });
}

export default ExpandedViewForProductAttribute;
